(ns iris.auth.api
  "Lightweight authentication state abstraction.
   
   Provides a facade over Firebase auth to reduce direct dependencies.
   All application code should use this API instead of iris.firebase for auth."
  (:require
   [iris.firebase :as fb]
   [iris.globals :as globals]))

;; ============================================================================
;; Authentication State Checks
;; ============================================================================

(defn authenticated?
  "Check if user is authenticated (either via Firebase or JWT).
   
   This is a convenience wrapper that checks Firebase auth state.
   You could also check (some? @globals/fbjwt-payload) instead."
  []
  (fb/authenticated?))

(defn current-user
  "Get current user object from Firebase.
   
   Returns the Firebase user object or nil."
  []
  (fb/current-user))

(defn user-atom
  "Get the Firebase user atom for reactive updates.
   
   Use with @(auth/user-atom) to get current value."
  []
  fb/user-atom)

(defn user-id
  "Get current user ID from JWT payload.
   
   This is independent of Firebase - gets UID from Sokrates JWT."
  []
  (:uid @globals/fbjwt-payload))

;; ============================================================================
;; Authentication Promises
;; ============================================================================

(defn wait-for-user-promise
  "Wait for Firebase user to be authenticated.
   
   Returns a promise that resolves with the Firebase user object."
  []
  (fb/wait-for-auth-user-promise))

(defn wait-for-user
  "Wait for Firebase user to be authenticated (channel-based).
   
   Returns a core.async channel that yields the Firebase user object."
  []
  (fb/wait-for-auth-user))

(defn wait-for-user-with-timeout
  "Wait for Firebase user with timeout.
   
   timeout-ms - Timeout in milliseconds
   callback - Function called with user (or nil if timeout)"
  [timeout-ms callback]
  (fb/wait-for-auth-user-with-timeout timeout-ms callback))

;; ============================================================================
;; Authentication Initialization
;; ============================================================================

(defn init-auth!
  "Initialize Firebase authentication with a token.
   
   token - Firebase custom token (from Sokrates backend)"
  [token]
  (fb/init-auth! token))

;; ============================================================================
;; Authentication Callbacks
;; ============================================================================

(defn on-auth-ready
  "Register a callback to be called when authentication is ready.
   
   callback - Function to call with user object when auth completes"
  [callback]
  (fb/on-auth-ready callback))
